var plusImgCanvas = function () {
    var c = document.getElementById("plusIcon");
    c.height = 14;
    c.width = 16;
    var cx = c.getContext("2d");
    cx.fillStyle = "rgba(255,255,255,1)";
    cx.fillRect(0, 0, 1, 1);
    cx.fillRect(1, 0, 1, 1);
    cx.fillRect(2, 0, 1, 1);
    cx.fillRect(3, 0, 1, 1);
    cx.fillRect(4, 0, 1, 1);
    cx.fillRect(5, 0, 1, 1);
    cx.fillRect(6, 0, 1, 1);
    cx.fillStyle = "rgba(254,254,254,1)";
    cx.fillRect(7, 0, 1, 1);
    cx.fillRect(8, 0, 1, 1);
    cx.fillStyle = "rgba(255,255,255,1)";
    cx.fillRect(9, 0, 1, 1);
    cx.fillRect(10, 0, 1, 1);
    cx.fillRect(11, 0, 1, 1);
    cx.fillRect(12, 0, 1, 1);
    cx.fillRect(13, 0, 1, 1);
    cx.fillRect(14, 0, 1, 1);
    cx.fillRect(15, 0, 1, 1);
    cx.fillRect(0, 1, 1, 1);
    cx.fillRect(1, 1, 1, 1);
    cx.fillRect(2, 1, 1, 1);
    cx.fillRect(3, 1, 1, 1);
    cx.fillRect(4, 1, 1, 1);
    cx.fillRect(5, 1, 1, 1);
    cx.fillStyle = "rgba(99,99,99,1)";
    cx.fillRect(6, 1, 1, 1);
    cx.fillStyle = "rgba(0,0,0,1)";
    cx.fillRect(7, 1, 1, 1);
    cx.fillRect(8, 1, 1, 1);
    cx.fillStyle = "rgba(99,99,99,1)";
    cx.fillRect(9, 1, 1, 1);
    cx.fillStyle = "rgba(255,255,255,1)";
    cx.fillRect(10, 1, 1, 1);
    cx.fillRect(11, 1, 1, 1);
    cx.fillRect(12, 1, 1, 1);
    cx.fillRect(13, 1, 1, 1);
    cx.fillRect(14, 1, 1, 1);
    cx.fillRect(15, 1, 1, 1);
    cx.fillRect(0, 2, 1, 1);
    cx.fillRect(1, 2, 1, 1);
    cx.fillRect(2, 2, 1, 1);
    cx.fillRect(3, 2, 1, 1);
    cx.fillRect(4, 2, 1, 1);
    cx.fillRect(5, 2, 1, 1);
    cx.fillStyle = "rgba(89,89,89,1)";
    cx.fillRect(6, 2, 1, 1);
    cx.fillStyle = "rgba(25,25,25,1)";
    cx.fillRect(7, 2, 1, 1);
    cx.fillRect(8, 2, 1, 1);
    cx.fillStyle = "rgba(89,89,89,1)";
    cx.fillRect(9, 2, 1, 1);
    cx.fillStyle = "rgba(255,255,255,1)";
    cx.fillRect(10, 2, 1, 1);
    cx.fillRect(11, 2, 1, 1);
    cx.fillRect(12, 2, 1, 1);
    cx.fillRect(13, 2, 1, 1);
    cx.fillRect(14, 2, 1, 1);
    cx.fillRect(15, 2, 1, 1);
    cx.fillRect(0, 3, 1, 1);
    cx.fillRect(1, 3, 1, 1);
    cx.fillRect(2, 3, 1, 1);
    cx.fillRect(3, 3, 1, 1);
    cx.fillRect(4, 3, 1, 1);
    cx.fillRect(5, 3, 1, 1);
    cx.fillStyle = "rgba(91,91,91,1)";
    cx.fillRect(6, 3, 1, 1);
    cx.fillStyle = "rgba(25,25,25,1)";
    cx.fillRect(7, 3, 1, 1);
    cx.fillRect(8, 3, 1, 1);
    cx.fillStyle = "rgba(91,91,91,1)";
    cx.fillRect(9, 3, 1, 1);
    cx.fillStyle = "rgba(255,255,255,1)";
    cx.fillRect(10, 3, 1, 1);
    cx.fillRect(11, 3, 1, 1);
    cx.fillRect(12, 3, 1, 1);
    cx.fillRect(13, 3, 1, 1);
    cx.fillRect(14, 3, 1, 1);
    cx.fillRect(15, 3, 1, 1);
    cx.fillRect(0, 4, 1, 1);
    cx.fillRect(1, 4, 1, 1);
    cx.fillRect(2, 4, 1, 1);
    cx.fillRect(3, 4, 1, 1);
    cx.fillRect(4, 4, 1, 1);
    cx.fillRect(5, 4, 1, 1);
    cx.fillStyle = "rgba(98,98,98,1)";
    cx.fillRect(6, 4, 1, 1);
    cx.fillStyle = "rgba(25,25,25,1)";
    cx.fillRect(7, 4, 1, 1);
    cx.fillRect(8, 4, 1, 1);
    cx.fillStyle = "rgba(98,98,98,1)";
    cx.fillRect(9, 4, 1, 1);
    cx.fillStyle = "rgba(255,255,255,1)";
    cx.fillRect(10, 4, 1, 1);
    cx.fillRect(11, 4, 1, 1);
    cx.fillRect(12, 4, 1, 1);
    cx.fillRect(13, 4, 1, 1);
    cx.fillRect(14, 4, 1, 1);
    cx.fillRect(15, 4, 1, 1);
    cx.fillRect(0, 5, 1, 1);
    cx.fillStyle = "rgba(245,245,245,1)";
    cx.fillRect(1, 5, 1, 1);
    cx.fillStyle = "rgba(56,56,56,1)";
    cx.fillRect(2, 5, 1, 1);
    cx.fillStyle = "rgba(61,61,61,1)";
    cx.fillRect(3, 5, 1, 1);
    cx.fillStyle = "rgba(63,63,63,1)";
    cx.fillRect(4, 5, 1, 1);
    cx.fillStyle = "rgba(66,66,66,1)";
    cx.fillRect(5, 5, 1, 1);
    cx.fillStyle = "rgba(40,40,40,1)";
    cx.fillRect(6, 5, 1, 1);
    cx.fillStyle = "rgba(32,32,32,1)";
    cx.fillRect(7, 5, 1, 1);
    cx.fillRect(8, 5, 1, 1);
    cx.fillStyle = "rgba(40,40,40,1)";
    cx.fillRect(9, 5, 1, 1);
    cx.fillStyle = "rgba(66,66,66,1)";
    cx.fillRect(10, 5, 1, 1);
    cx.fillStyle = "rgba(63,63,63,1)";
    cx.fillRect(11, 5, 1, 1);
    cx.fillStyle = "rgba(61,61,61,1)";
    cx.fillRect(12, 5, 1, 1);
    cx.fillStyle = "rgba(56,56,56,1)";
    cx.fillRect(13, 5, 1, 1);
    cx.fillStyle = "rgba(246,246,246,1)";
    cx.fillRect(14, 5, 1, 1);
    cx.fillStyle = "rgba(255,255,255,1)";
    cx.fillRect(15, 5, 1, 1);
    cx.fillRect(0, 6, 1, 1);
    cx.fillStyle = "rgba(204,204,204,1)";
    cx.fillRect(1, 6, 1, 1);
    cx.fillStyle = "rgba(7,7,7,1)";
    cx.fillRect(2, 6, 1, 1);
    cx.fillStyle = "rgba(28,28,28,1)";
    cx.fillRect(3, 6, 1, 1);
    cx.fillRect(4, 6, 1, 1);
    cx.fillRect(5, 6, 1, 1);
    cx.fillStyle = "rgba(32,32,32,1)";
    cx.fillRect(6, 6, 1, 1);
    cx.fillStyle = "rgba(34,34,34,1)";
    cx.fillRect(7, 6, 1, 1);
    cx.fillRect(8, 6, 1, 1);
    cx.fillStyle = "rgba(32,32,32,1)";
    cx.fillRect(9, 6, 1, 1);
    cx.fillStyle = "rgba(28,28,28,1)";
    cx.fillRect(10, 6, 1, 1);
    cx.fillRect(11, 6, 1, 1);
    cx.fillRect(12, 6, 1, 1);
    cx.fillStyle = "rgba(7,7,7,1)";
    cx.fillRect(13, 6, 1, 1);
    cx.fillStyle = "rgba(204,204,204,1)";
    cx.fillRect(14, 6, 1, 1);
    cx.fillStyle = "rgba(255,255,255,1)";
    cx.fillRect(15, 6, 1, 1);
    cx.fillRect(0, 7, 1, 1);
    cx.fillStyle = "rgba(205,205,205,1)";
    cx.fillRect(1, 7, 1, 1);
    cx.fillStyle = "rgba(0,0,0,1)";
    cx.fillRect(2, 7, 1, 1);
    cx.fillStyle = "rgba(18,18,18,1)";
    cx.fillRect(3, 7, 1, 1);
    cx.fillRect(4, 7, 1, 1);
    cx.fillRect(5, 7, 1, 1);
    cx.fillStyle = "rgba(29,29,29,1)";
    cx.fillRect(6, 7, 1, 1);
    cx.fillStyle = "rgba(34,34,34,1)";
    cx.fillRect(7, 7, 1, 1);
    cx.fillRect(8, 7, 1, 1);
    cx.fillStyle = "rgba(29,29,29,1)";
    cx.fillRect(9, 7, 1, 1);
    cx.fillStyle = "rgba(18,18,18,1)";
    cx.fillRect(10, 7, 1, 1);
    cx.fillRect(11, 7, 1, 1);
    cx.fillRect(12, 7, 1, 1);
    cx.fillStyle = "rgba(0,0,0,1)";
    cx.fillRect(13, 7, 1, 1);
    cx.fillStyle = "rgba(205,205,205,1)";
    cx.fillRect(14, 7, 1, 1);
    cx.fillStyle = "rgba(255,255,255,1)";
    cx.fillRect(15, 7, 1, 1);
    cx.fillRect(0, 8, 1, 1);
    cx.fillRect(1, 8, 1, 1);
    cx.fillStyle = "rgba(164,164,164,1)";
    cx.fillRect(2, 8, 1, 1);
    cx.fillStyle = "rgba(161,161,161,1)";
    cx.fillRect(3, 8, 1, 1);
    cx.fillStyle = "rgba(162,162,162,1)";
    cx.fillRect(4, 8, 1, 1);
    cx.fillStyle = "rgba(173,173,173,1)";
    cx.fillRect(5, 8, 1, 1);
    cx.fillStyle = "rgba(67,67,67,1)";
    cx.fillRect(6, 8, 1, 1);
    cx.fillStyle = "rgba(29,29,29,1)";
    cx.fillRect(7, 8, 1, 1);
    cx.fillRect(8, 8, 1, 1);
    cx.fillStyle = "rgba(67,67,67,1)";
    cx.fillRect(9, 8, 1, 1);
    cx.fillStyle = "rgba(173,173,173,1)";
    cx.fillRect(10, 8, 1, 1);
    cx.fillStyle = "rgba(162,162,162,1)";
    cx.fillRect(11, 8, 1, 1);
    cx.fillStyle = "rgba(161,161,161,1)";
    cx.fillRect(12, 8, 1, 1);
    cx.fillStyle = "rgba(163,163,163,1)";
    cx.fillRect(13, 8, 1, 1);
    cx.fillStyle = "rgba(255,255,255,1)";
    cx.fillRect(14, 8, 1, 1);
    cx.fillRect(15, 8, 1, 1);
    cx.fillRect(0, 9, 1, 1);
    cx.fillRect(1, 9, 1, 1);
    cx.fillRect(2, 9, 1, 1);
    cx.fillRect(3, 9, 1, 1);
    cx.fillRect(4, 9, 1, 1);
    cx.fillRect(5, 9, 1, 1);
    cx.fillStyle = "rgba(95,95,95,1)";
    cx.fillRect(6, 9, 1, 1);
    cx.fillStyle = "rgba(25,25,25,1)";
    cx.fillRect(7, 9, 1, 1);
    cx.fillRect(8, 9, 1, 1);
    cx.fillStyle = "rgba(95,95,95,1)";
    cx.fillRect(9, 9, 1, 1);
    cx.fillStyle = "rgba(255,255,255,1)";
    cx.fillRect(10, 9, 1, 1);
    cx.fillRect(11, 9, 1, 1);
    cx.fillRect(12, 9, 1, 1);
    cx.fillRect(13, 9, 1, 1);
    cx.fillRect(14, 9, 1, 1);
    cx.fillRect(15, 9, 1, 1);
    cx.fillRect(0, 10, 1, 1);
    cx.fillRect(1, 10, 1, 1);
    cx.fillRect(2, 10, 1, 1);
    cx.fillRect(3, 10, 1, 1);
    cx.fillRect(4, 10, 1, 1);
    cx.fillRect(5, 10, 1, 1);
    cx.fillStyle = "rgba(91,91,91,1)";
    cx.fillRect(6, 10, 1, 1);
    cx.fillStyle = "rgba(25,25,25,1)";
    cx.fillRect(7, 10, 1, 1);
    cx.fillRect(8, 10, 1, 1);
    cx.fillStyle = "rgba(91,91,91,1)";
    cx.fillRect(9, 10, 1, 1);
    cx.fillStyle = "rgba(255,255,255,1)";
    cx.fillRect(10, 10, 1, 1);
    cx.fillRect(11, 10, 1, 1);
    cx.fillRect(12, 10, 1, 1);
    cx.fillRect(13, 10, 1, 1);
    cx.fillRect(14, 10, 1, 1);
    cx.fillRect(15, 10, 1, 1);
    cx.fillRect(0, 11, 1, 1);
    cx.fillRect(1, 11, 1, 1);
    cx.fillRect(2, 11, 1, 1);
    cx.fillRect(3, 11, 1, 1);
    cx.fillRect(4, 11, 1, 1);
    cx.fillRect(5, 11, 1, 1);
    cx.fillStyle = "rgba(82,82,82,1)";
    cx.fillRect(6, 11, 1, 1);
    cx.fillStyle = "rgba(18,18,18,1)";
    cx.fillRect(7, 11, 1, 1);
    cx.fillRect(8, 11, 1, 1);
    cx.fillStyle = "rgba(82,82,82,1)";
    cx.fillRect(9, 11, 1, 1);
    cx.fillStyle = "rgba(255,255,255,1)";
    cx.fillRect(10, 11, 1, 1);
    cx.fillRect(11, 11, 1, 1);
    cx.fillRect(12, 11, 1, 1);
    cx.fillRect(13, 11, 1, 1);
    cx.fillRect(14, 11, 1, 1);
    cx.fillRect(15, 11, 1, 1);
    cx.fillRect(0, 12, 1, 1);
    cx.fillRect(1, 12, 1, 1);
    cx.fillRect(2, 12, 1, 1);
    cx.fillRect(3, 12, 1, 1);
    cx.fillRect(4, 12, 1, 1);
    cx.fillRect(5, 12, 1, 1);
    cx.fillStyle = "rgba(170,170,170,1)";
    cx.fillRect(6, 12, 1, 1);
    cx.fillStyle = "rgba(67,67,67,1)";
    cx.fillRect(7, 12, 1, 1);
    cx.fillRect(8, 12, 1, 1);
    cx.fillStyle = "rgba(169,169,169,1)";
    cx.fillRect(9, 12, 1, 1);
    cx.fillStyle = "rgba(255,255,255,1)";
    cx.fillRect(10, 12, 1, 1);
    cx.fillRect(11, 12, 1, 1);
    cx.fillRect(12, 12, 1, 1);
    cx.fillRect(13, 12, 1, 1);
    cx.fillRect(14, 12, 1, 1);
    cx.fillRect(15, 12, 1, 1);
    cx.fillRect(0, 13, 1, 1);
    cx.fillRect(1, 13, 1, 1);
    cx.fillRect(2, 13, 1, 1);
    cx.fillRect(3, 13, 1, 1);
    cx.fillRect(4, 13, 1, 1);
    cx.fillRect(5, 13, 1, 1);
    cx.fillRect(6, 13, 1, 1);
    cx.fillRect(7, 13, 1, 1);
    cx.fillRect(8, 13, 1, 1);
    cx.fillRect(9, 13, 1, 1);
    cx.fillRect(10, 13, 1, 1);
    cx.fillRect(11, 13, 1, 1);
    cx.fillRect(12, 13, 1, 1);
    cx.fillRect(13, 13, 1, 1);
    cx.fillRect(14, 13, 1, 1);
    cx.fillRect(15, 13, 1, 1);
    return c;
};

export default plusImgCanvas;
